/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

import { delPersonnel } from '@/api/ajax';
import OccupationAuthStatus from '@/components/Occupation/AuthStatus';
import { enableDisablePeopleProjectUser } from '@/api/ajax.js';
import { moneyFixed } from '@/tools/money.js';
import AddUser from '../child/add-user.vue';
import AddUserPark from '../child/add-user-park.vue';
import { OPEN_STATUS_MAPPING } from '@/common/constants/bank';
// 醒目状态
const createDot = (h, { color, text }) => {
  return h(
    'div',
    {
      display: 'flex',
      alignItems: 'center'
    },
    [
      h('span', {
        style: {
          display: 'inline-block',
          width: '6px',
          height: '6px',
          marginRight: '6px',
          borderRadius: '50%',
          background: `${color}`
        }
      }),
      h('span', text)
    ]
  );
};
const isNextMonthAddMap = {
  0: '不邀请',
  1: '邀请'
};
// // 获取当前项目状态
// const getCurrentCsoStatus = () => {
//   const currentPerojectPersonnelCsoStatus = +localStorage.currentPerojectPersonnelCsoStatus;
//   return Boolean(currentPerojectPersonnelCsoStatus);
// };
const ASSIGN_TASK_AUTHSTATE = {
  '0': '',
  '1': '等待确认',
  '2': '审核驳回',
  '3': '修改完成'
};
// 入驻状态
const IN_STATUS = {
  0: '未入驻',
  1: '已入驻',
  2: '已退出',
  3: '不可入驻'
};

export const struct1 = {
  selection: {
    type: 'selection',
    prop: 'index',
    selectable: row => !(row.superviseStatus === 3 || row.zbBlackStatus === 2),
    reserve: true
  },
  index: {
    width: '60px',
    label: '序号',
    type: 'index'
  },
  //用户id
  userId: {
    prop: 'userId',
    label: '用户id'
  },
  //姓名（也可以叫经营者）
  fullName: {
    prop: 'fullName',
    label: '姓名',
    width: '100px'
  },
  //手机号
  phone: {
    prop: 'phone',
    label: '手机号',
    width: '120px'
  },
  openStatus: {
    width: '105px',
    label: '项目支付通道',
    prop: 'openStatus',
    render(h, ctx, row) {
      const { payPassagewayCode } = ctx.parent.$store.state.homeProject;
      let val = '-';
      if (payPassagewayCode) {
        val = OPEN_STATUS_MAPPING[row.openStatus].label;
      }
      return <span>{val}</span>;
    }
  },
  personLabel: {
    label: '人员标签',
    prop: 'userTag',
    width: '170px',
    render: (h, ctx, row) => {
      return (
        <el-button
          type="text"
          onClick={() => {
            const vm = ctx.parent;
            const userEnterpriseType =
              vm.$store.state.homeProject.userEnterpriseType;
            vm.$xrkDialog.call(vm.$parent, {
              showConfirm: false,
              showCancel: false,
              ...{ title: '修改标签', width: '450px' },
              $slots: {
                default: h(userEnterpriseType === 3 ? AddUserPark : AddUser, {
                  props: {
                    editUserTag: true,
                    defaultObj: {
                      id: row.id,
                      userTag: row.userTag,
                      fullName: row.fullName,
                      phone: row.phone,
                      enterpriseName: row.enterpriseName
                    }
                  }
                })
              }
            });
          }}
        >
          {row['userTag'] || '未设置'}
        </el-button>
      );
    }
  },
  taskPlanTaskDt: {
    label: '预采购时间',
    prop: 'taskPlanTaskDt',
    width: '120px'
  },
  taskPlanTaskSum: {
    label: '剩余预采购任务量',
    prop: 'taskPlanTaskSum',
    width: '120px',
    formatter: (r, c, v) => {
      return v || 0;
    }
  },
  //项目id
  projectId: {
    prop: 'projectId',
    label: '项目id'
  },
  //是否可执行项目 1 启用 2 停用
  status: {
    prop: 'status',
    label: '是否可执行项目',
    width: '120px',
    render: (h, ctx, row) => {
      let text = [null, '是', '否'][+row.status];
      let color = [null, '#67C23A', '#F56C6C'][+row.status];
      return createDot(h, {
        color,
        text
      });
    }
  },
  isNowExecute: {
    prop: 'isNowExecute',
    label: '是否是当期人员',
    width: '120px',
    render: (h, ctx, row) => {
      let text = ['否', '是'][+row.isNowExecute];
      let color = ['#F56C6C', '#67C23A'][+row.isNowExecute];
      return createDot(h, {
        color,
        text
      });
    }
  },
  //职业认证 0 未认证（审核中也属于未认证） 2 已认证
  occupationAuthStatus: {
    label: '职业认证',
    prop: 'occupationAuthStatus',
    render: (h, ctx, row) => {
      const { occupationAuthStatus, userId } = row;
      return h(OccupationAuthStatus, {
        props: {
          occupationAuthStatus,
          userId
        }
      });
    }
  },
  fullNameAlter: {
    label: '认证状态',
    render: (h, ctx, row) => {
      // 获得认证状态 0否 1是 http://yapi.jimijiayuan.cn/project/657/interface/api/15699
      // const { userAuthStatus } = row;
      // let USER_AUTHSTATUS_MAP = {
      //   0: '未认证',
      //   1: '已认证',
      //   2: '认证失败'
      // };
      // return h('div', USER_AUTHSTATUS_MAP[userAuthStatus]);
      const { v3PersonAuthStatus } = row;
      let USER_AUTHSTATUS_MAP = {
        0: '未认证',
        1: '已认证'
      };
      return h('div', USER_AUTHSTATUS_MAP[v3PersonAuthStatus]);
    }
  },
  passingTaskSumPlatform: {
    prop: 'passingTaskSumPlatform',
    label: '系统接收中任务量',
    width: '120px',
    formatter: (r, c, v) => {
      return v || 0;
    }
  },
  numberOfReceivedTasks: {
    prop: 'numberOfReceivedTasks',
    label: '系统已接收任务量',
    width: '120px',
    formatter: (r, c, v) => {
      return v || 0;
    }
  },
  //状态 0 未入驻 1 已入驻 2退出
  inStatus: {
    prop: 'inStatus',
    label: '入驻状态',
    formatter: (r, c, v) => {
      return IN_STATUS[v];
    }
  },
  //项目结算单价cso
  csoPrice: {
    prop: 'csoPrice',
    label: '项目结算单价（不含税）',
    width: '120px',
    formatter: (r, c, v) => {
      return moneyFixed(v);
    }
  },
  //终端结算单价
  appPrice: {
    prop: 'appPrice',
    label: '终端结算单价',
    width: '120px',
    formatter: (r, c, v) => {
      return moneyFixed(v);
    }
  },
  //项目结算总价
  csoPriceTotal: {
    prop: 'csoPriceTotal',
    label: '预计项目结算金额（不含税）',
    width: '120px',
    formatter: (r, c, v) => {
      return moneyFixed(v);
    }
  },
  //终端结算总价
  appPriceTotal: {
    prop: 'appPriceTotal',
    label: '预计终端结算金额',
    width: '120px',
    formatter: (r, c, v) => {
      return moneyFixed(v);
    }
  },
  //实名认证 0 未认证 1 认证成功 2认证失败   注意只有未认证的条件才能有删除操作
  userAuthStatus: {
    prop: 'userAuthStatus',
    label: '实名认证',
    formatter: (r, c, v) => {
      return ['未认证', '认证成功', '认证失败'][v]; //注意只有未认证的条件才能有删除操作
    }
  },
  //个体名称
  enterpriseName: {
    prop: 'enterpriseName',
    label: '个体名称',
    width: '120px'
  },
  operation: {
    width: '160px',
    label: '操作',
    prop: 'handler',
    render(h, ctx, row) {
      let vm = ctx.parent;
      const { userTaskId } = row;
      const { userAuthStatus } = row;
      const isAuth = +userAuthStatus === 1;
      const currentProject = window.localStorage.getItem(
        'currentPerojectPersonnelCsoStatus'
      );
      const removePersonById = () => {
        vm.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            delPersonnel({
              userId: row.userId,
              projectId: row.projectId
            })
              .then(() => {
                vm.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                vm.$parent.forceReload();
              })
              .catch(() => {});
          })
          .catch(() => {});
      };

      const changeState = (status, text, text2) => {
        vm.$parent
          .$confirm(`${text}后该自然人将${text2}继续执行项目`)
          .then(res => {
            // console.log(res);
            /**
             * projectId	是 项目id
             * status	    是  状态  1 启用 2 停用
             */
            const { projectId, userId } = row;
            enableDisablePeopleProjectUser({
              status,
              projectId,
              userId
            }).then(res => {
              vm.$parent.$message({
                type: 'success',
                message: res.data.message
              });
              vm.$parent.forceReload();
            });
          })
          .catch(() => {
            // console.log('err');
          });
      };
      return (
        <div>
          {+row.status === 1 ? (
            <el-button
              type="text"
              onClick={changeState.bind(null, '2', '停用', '不能')}
            >
              停用
            </el-button>
          ) : (
            <el-button
              type="text"
              onClick={changeState.bind(null, '1', '启用', '可以')}
            >
              启用
            </el-button>
          )}
          <el-button
            type="text"
            disabled={isAuth || +currentProject === 1}
            onClick={removePersonById}
          >
            删除
          </el-button>
        </div>
      );
    }
  },
  //资质审核状态
  certificationStatus: {
    prop: 'certificationStatus',
    label: '资质审核状态',
    width: '120px',
    formatter: (r, c, v) => {
      if (r.zbBlackStatus == 2 || r.superviseStatus == 3) {
        return '-';
      }
      return { 1: '待审核', 2: '审核通过', 3: '审核未通过' }[v] || '-';
    }
  },
  taskSumNoFinishPrice: {
    label: '预采购金额（含税）',
    width: 200,
    prop: 'taskSumNoFinishPrice',
    render: (h, ctx, row) => {
      return (
        <span>
          {!['', null, undefined].includes(row.taskSumNoFinishPrice)
            ? moneyFixed(row.taskSumNoFinishPrice)
            : '-'}
        </span>
      );
    }
  }
};
export default {
  index: {
    width: '80px',
    label: '序号',
    type: 'index'
  },
  fullName: {
    label: '姓名',
    prop: 'fullName'
  },
  occupationAuthStatus: {
    label: '职业认证',
    prop: 'occupationAuthStatus',
    render: (h, ctx, row) => {
      const { occupationAuthStatus, userId } = row;
      return h(OccupationAuthStatus, {
        props: {
          occupationAuthStatus,
          userId
        }
      });
    }
  },
  fullNameAlter: {
    label: '认证状态',
    render: (h, ctx, row) => {
      // 获得认证状态 0否 1是 http://yapi.jimijiayuan.cn/project/657/interface/api/15699
      // const { userAuthStatus } = row;
      // let USER_AUTHSTATUS_MAP = {
      //   0: '未认证',
      //   1: '已认证',
      //   2: '认证失败'
      // };
      // return h('div', USER_AUTHSTATUS_MAP[userAuthStatus]);
      const { v3PersonAuthStatus } = row;
      let USER_AUTHSTATUS_MAP = {
        0: '未认证',
        1: '已认证'
      };
      return h('div', USER_AUTHSTATUS_MAP[v3PersonAuthStatus]);
    }
  },
  phone: {
    label: '手机号',
    prop: 'phone'
  },
  taskPlanTaskDt: {
    label: '预采购时间',
    prop: 'taskPlanTaskDt'
  },
  taskPlanTaskSum: {
    label: '剩余预采购任务量',
    prop: 'taskPlanTaskSum'
  },
  isNowExecute: {
    label: '是否是当期人员',
    prop: 'isNowExecute', // 0 否   1是
    formatter(r, c, v) {
      return ['否', '是'][+v] || '-';
    }
  },
  enterpriseName: {
    label: '个体名称',
    prop: 'enterpriseName'
  },
  taskSum: {
    label: '计划任务量',
    prop: 'taskSum',
    formatter(r, c, v) {
      return v || '-';
    }
  },
  finishSum: {
    label: '审核通过量',
    prop: 'finishSum',
    formatter(r, c, v) {
      return v || '-';
    }
  },
  priceStr: {
    label: '项目结算单价(不含税)',
    prop: 'priceStr'
  },
  totalPriceStr: {
    label: '预计项目结算金额(不含税)',
    prop: 'totalPriceStr'
  },
  csoPriceStr: {
    label: '终端结算单价',
    prop: 'csoPriceStr'
  },
  totalCsoPriceStr: {
    label: '预计终端结算金额',
    prop: 'totalCsoPriceStr'
  },
  status: {
    label: '入驻状态',
    prop: 'statusStr'
  },
  auto: {
    label: '次月自动邀请',
    prop: 'isNextMonthAdd',
    formatter(row) {
      return isNextMonthAddMap[row.isNextMonthAdd];
    }
  },
  handler: {
    width: '230px',
    label: '设置',
    prop: 'handler',
    render(h, ctx, row) {
      let vm = ctx.parent;
      const { userTaskId } = row;

      const { userAuthStatus } = row;
      const isAuth = +userAuthStatus === 1;
      const currentProject = window.localStorage.getItem(
        'currentPerojectPersonnelCsoStatus'
      );
      const removePersonById = () => {
        vm.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            delPersonnel({
              userId: row.userId,
              projectId: row.projectId
            })
              .then(() => {
                vm.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                vm.$parent.forceReload();
              })
              .catch(() => {});
          })
          .catch(() => {});
      };

      const changeState = (status, text, text2) => {
        vm.$parent
          .$confirm(`${text}后该自然人将${text2}继续执行项目`)
          .then(res => {
            // console.log(res);
          })
          .catch(err => {
            // console.log('err');
          });
      };
      return (
        <div>
          <el-button
            type="text"
            disabled={isAuth || +currentProject === 1}
            onClick={removePersonById}
          >
            删除
          </el-button>
          {+row.status === 1 ? (
            <el-button
              type="text"
              onClick={changeState.bind(null, '0', '停用', '不能')}
            >
              停用
            </el-button>
          ) : (
            <el-button
              type="text"
              onClick={changeState.bind(null, '1', '启用', '可以')}
            >
              启用
            </el-button>
          )}
        </div>
      );
    }
  }
};
